import moment from 'moment';
import { html } from 'lit-html';
import { input } from './input';

// https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
const DEFAULT_FORMAT = 'DD MMM YYYY HH:mm';

const format = (formatStr, str, utc) => utc
  ? moment.utc(str).format(formatStr || DEFAULT_FORMAT)
  : moment(str).format(formatStr || DEFAULT_FORMAT);

export const date = ({
  cellData,
  column = {},
  editmode,
  selected,
  editing,
  dateOptions,
  utc = true
}) => {
  if (editmode) {
    const date = utc ? cellData - moment(cellData).utcOffset() * 1000 * 60 : cellData;

    // if allowed to select future year in the date field, override the date picker dropdowns options with maxYear to next year
    const datePickerOptions = dateOptions?.allowFutureYear
    ? { dropdowns: { maxYear: new Date().getFullYear() + 1 } }
    : {};
    return input({ cellData: date, column, editmode, selected, datePickerOptions });
  }
  if (editing && selected.length > 1) {
    return '(multiple)';
  }
  if (!cellData || typeof cellData !== 'number') return '';
  const date = new Date(cellData);
  const content = format(column.dateFormat, cellData, utc);
  const datetime = date.toISOString();
  return html`<time datetime="${datetime}">${content}</time>`;
};
